import { customButtonDefault } from '@modules/edit';
import {
  type ComponentLayer,
  type ComponentLayerAnimation,
  FeatureType,
} from '@types';

/** 最大图层数 */
export const C_LAYER_MAX = 50;

/** 图层默认尺寸 */
export const C_LAYER_DEFAULT_SIZE: ComponentLayer['size'][
  | 'desktop'
  | 'mobile'] = {
  type: 0,
  lockAspectRatio: 1,
  adaptiveBy: 0,
  width: 0,
  height: 0,
};

/** 图层默认图标位置 */
export const C_LAYER_DEFAULT_ICON_POS: ComponentLayer['icon'][
  | 'desktop'
  | 'mobile'] = {
  edge: 'center',
  offsetX: 0,
  offsetY: 0,
};

export const C_LAYER_DEFAULT_ANIMATION: ComponentLayerAnimation = {
  type: 0,
  duration: 2,
  delay: 0,
  loopCount: 0,
  playEndAction: 0,
  stayMode: 0,
  stayDuration: 5,
};

/** 图层默认值 */
export const C_LAYER_DEFAULT: Required<ComponentLayer> = {
  id: '',
  title: '',
  zIndex: 0,
  visible: true,
  locked: false,
  displayMode: 0,
  bgColor: '0,0,0,0.6',
  turnOffBgMusicOnShow: 0,
  turnOffRotateOnShow: 0,
  devices: [0, 1],
  size: {
    desktop: C_LAYER_DEFAULT_SIZE,
    mobile: C_LAYER_DEFAULT_SIZE,
  },
  icon: {
    type: 0,
    mediaType: 0,
    mediaId: 0,
    mediaUrl: '',
    desktop: C_LAYER_DEFAULT_ICON_POS,
    mobile: C_LAYER_DEFAULT_ICON_POS,
  },
  data: customButtonDefault(FeatureType.noFunc),
  animation: C_LAYER_DEFAULT_ANIMATION,
  enterAnimation: C_LAYER_DEFAULT_ANIMATION,
  exitAnimation: C_LAYER_DEFAULT_ANIMATION,
  layerControl: {
    mode: 0,
    data: [],
  },
  hideInClearMode: 1,
};
